module.exports = __webpack_public_path__ + "static/media/tec.ecc72c8d.png";